module.exports = __webpack_public_path__ + "static/media/ic-inbound-call.3a3d022d.svg";